import React from 'react';

/**
 * ContentContainer
 *
 * Responsive scrollable content area.
 * Constrains maximum width, applies consistent padding,
 * and handles vertical overflow scrolling.
 *
 * Props:
 *   children    — page content
 *   maxWidth    — Tailwind max-width class (default: 'max-w-screen-2xl')
 *   noPadding   — boolean, removes default padding (for full-bleed views)
 *   className   — additional Tailwind classes
 */
function ContentContainer({
  children,
  maxWidth = 'max-w-screen-2xl',
  noPadding = false,
  scrollable = true,
  className = '',
}) {
  return (
    <main className={`flex-1 ${scrollable ? 'overflow-y-auto' : 'overflow-hidden'}`} style={{ background: 'var(--axial-bg)' }}>
      <div
        className={`
          mx-auto w-full h-full
          ${maxWidth}
          ${noPadding ? '' : 'px-4 sm:px-6 lg:px-8 py-6'}
          ${className}
        `}
      >
        {children}
      </div>
    </main>
  );
}

export default ContentContainer;
